import { gql } from '@apollo/client';

export const CREATE_COMPLETED_TOURS_MUTATION = gql`
  mutation CreateCompletedTour($data: CompletedTourCreateInput!) {
    createOneCompletedTour(data: $data) {
      id
      name
    }
  }
`;

export const FETCH_MANY_COMPLETED_TOURS_QUERY = gql`
  query ($where: CompletedTourWhereInput) {
    completedTours(where: $where) {
      id
      name
    }
  }
`;
